import type { FC, PropsWithChildren } from "react";

import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const SearchEnginesListWrapper = styled(FlexColumn)`
    box-sizing: border-box;
    gap: 12px;
    min-height: 100px;
    max-height: 460px;
    flex: 1 1 0;
`;
export const AddNewSearchEngineButtonWrapper = styled.div`
    width: 100%;
    margin: 10px 0;
`;

export const Hidden: FC<PropsWithChildren<{ hidden?: boolean }>> = ({ children, hidden = true }) => {
    return hidden ? null : children;
};

export const ModalTitle = styled.div`
    line-height: 24px;
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ModalFooter = styled(FlexRow)`
    justify-content: flex-end;
`;
